"use strict";

var _regeneratorRuntime = require("C:\\TaryagAnalytics\\projects-Git\\code\\basehaseferclient\\basehasefer\\node_modules\\@babel\\runtime/regenerator");

var _classCallCheck = require("C:\\TaryagAnalytics\\projects-Git\\code\\basehaseferclient\\basehasefer\\node_modules\\@babel\\runtime/helpers/classCallCheck");

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createSpeechlySpeechRecognition = void 0;

var browser_client_1 = require("@speechly/browser-client");

var types_1 = require("./types");
/**
 * Returns a SpeechRecognition implementation that uses a given Speechly app ID
 * to generate transcriptions using the Speechly API
 *
 * @param appId - Speechly app ID
 * @returns Class that implements the SpeechRecognition interface
 * @public
 */


var createSpeechlySpeechRecognition = function createSpeechlySpeechRecognition(appId) {
  var _a;

  var _b;

  var browserSupportsAudioApis = typeof window !== 'undefined' && ((_a = window.navigator) === null || _a === void 0 ? void 0 : _a.mediaDevices) !== undefined && (window.AudioContext !== undefined || window.webkitAudioContext !== undefined);
  return _b = function SpeechlySpeechRecognition() {
    var _this = this;

    _classCallCheck(this, SpeechlySpeechRecognition);

    this.clientInitialised = false;
    this.aborted = false;
    this.transcribing = false;
    this.continuous = false;
    this.interimResults = false;

    this.onresult = function () {};

    this.onend = function () {};

    this.onerror = function () {};

    this.start = function () {
      return __awaiter(_this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                this.aborted = false;
                _context.next = 4;
                return this.initialise();

              case 4:
                _context.next = 6;
                return this.client.startContext();

              case 6:
                this.transcribing = true;
                _context.next = 12;
                break;

              case 9:
                _context.prev = 9;
                _context.t0 = _context["catch"](0);

                if (_context.t0 === browser_client_1.ErrNoAudioConsent) {
                  this.onerror(types_1.MicrophoneNotAllowedError);
                } else {
                  this.onerror(types_1.SpeechRecognitionFailedError);
                }

              case 12:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[0, 9]]);
      }));
    };

    this.stop = function () {
      return __awaiter(_this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2() {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return this._stop();

              case 2:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));
    };

    this.abort = function () {
      return __awaiter(_this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee3() {
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                this.aborted = true;
                _context3.next = 3;
                return this._stop();

              case 3:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));
    };

    this.initialise = function () {
      return __awaiter(_this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee4() {
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                if (this.clientInitialised) {
                  _context4.next = 4;
                  break;
                }

                _context4.next = 3;
                return this.client.initialize();

              case 3:
                this.clientInitialised = true;

              case 4:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));
    };

    this._stop = function () {
      return __awaiter(_this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee5() {
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                if (this.transcribing) {
                  _context5.next = 2;
                  break;
                }

                return _context5.abrupt("return");

              case 2:
                _context5.next = 4;
                return this.initialise();

              case 4:
                _context5.prev = 4;
                _context5.next = 7;
                return this.client.stopContext();

              case 7:
                this.transcribing = false;
                this.onend();
                _context5.next = 13;
                break;

              case 11:
                _context5.prev = 11;
                _context5.t0 = _context5["catch"](4);

              case 13:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this, [[4, 11]]);
      }));
    };

    this.handleResult = function (segment) {
      if (_this.aborted) {
        return;
      }

      if (!_this.interimResults && !segment.isFinal) {
        return;
      }

      var transcript = segment.words.map(function (x) {
        return x.value;
      }).filter(function (x) {
        return x;
      }).join(' ');
      var results = [{
        0: {
          transcript: transcript,
          confidence: 1
        },
        isFinal: segment.isFinal
      }];

      _this.onresult({
        results: results,
        resultIndex: 0
      });

      if (!_this.continuous && segment.isFinal) {
        _this.abort().catch(function () {}); // swallow errors

      }
    };

    this.client = new browser_client_1.Client({
      appId: appId
    });
    this.client.onSegmentChange(this.handleResult);
  }, _b.hasBrowserSupport = browserSupportsAudioApis, _b;
};

exports.createSpeechlySpeechRecognition = createSpeechlySpeechRecognition;
exports.default = exports.createSpeechlySpeechRecognition;